import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";

import './topBanner.scss';

const TopBanner = (props: {
    animationContainer: string
}) => {
    const { t } = useTranslation('browser');
    const [wholeBannerVisible, setWholeBannerVisible] = useState(true);

    useEffect(() => {
        handleEaseOut();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleEaseOut = () => {
        setTimeout(() => {
            setWholeBannerVisible(false);
            bindMouseEvents();
        }, 5000);
    }

    const bindMouseEvents = () => {
        const mouseLeaveWrapper = document.getElementById(`${props.animationContainer}`);
        mouseLeaveWrapper?.addEventListener('mouseleave', function() {
            setWholeBannerVisible(true);
        });
        mouseLeaveWrapper?.addEventListener('mouseenter', function() {
            setWholeBannerVisible(false);
        });
    }

    return <>
        {
            wholeBannerVisible && <div className="session-banner-container">
                <div className="top-content">
                    <img src="/media/circle-solid-icon.svg" className="icon" alt="" />
                    <span>{ t('SESSION_TOP_BANNER_TITLE') }</span>
                </div>
            </div>
        }
    </> 
}

export default TopBanner;